import React, { useEffect, useState } from 'react';
import pt from 'prop-types';
import cn from 'classnames';
import styles from './IncrementalButton.module.scss';

export default function IncrementalButton({
  className, initialCount, maxValue, minValue, onDecrement, onIncrement, quantity,
}) {
  const [count, setCount] = useState(initialCount);

  useEffect(() => {
    setCount(initialCount);
  }, [initialCount]);

  // `minValue` DEFAULTS TO 0, so every existing caller behaves exactly as before.
  // The gifts product screen passes 1: a quantity of zero there is not a choice
  // a customer is making, it is a dead end with a disabled button at the end of
  // it.
  const atMinimum = count <= minValue;

  const handleDecrement = () => {
    if (atMinimum) return;

    setCount((prev) => Math.max(prev - 1, minValue));
    onDecrement();
  };

  const handleIncrement = () => {
    setCount(((prev) => {
      const next = prev + 1;

      if (maxValue && (next > maxValue)) return prev;

      onIncrement();
      return next;
    }));
  };

  return (
    <div className={cn(styles.incrementalBtnsWrapper, className)}>
      <button
        onClick={handleDecrement}
        type="button"
        disabled={atMinimum}
        aria-label="Decrease quantity"
      >
        -
      </button>
      {quantity ? (
        <span>{count > 0 ? quantity : count}</span>
      ) : (
        <span>{count}</span>
      )}
      <button onClick={handleIncrement} type="button" aria-label="Increase quantity">+</button>
    </div>
  );
}

IncrementalButton.defaultProps = {
  className: '',
  initialCount: 0,
  maxValue: Number.POSITIVE_INFINITY,
  minValue: 0,
  onDecrement: () => {},
  onIncrement: () => {},
};

IncrementalButton.propTypes = {
  className: pt.string,
  initialCount: pt.number,
  maxValue: pt.number,
  minValue: pt.number,
  onDecrement: pt.func,
  onIncrement: pt.func,
};
